module.exports = __webpack_public_path__ + "static/media/sharecard-slide-price.37deaa61.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sharecard-slide-price.png
// module id = 2154
// module chunks = 4